jQuery(document).ready(function() {
  var stickyElementInSection = $('.sticky-element');
  var stickyElementContainer = $('#how-we-do');

  if(!stickyElementInSection.length || !stickyElementContainer.length || $(window).width() < 991) {
      stickyElementInSection.css('position', 'relative');
      stickyElementInSection.css('top', 0);

      return
  }

  $(window).scroll(function() {
      let windowPosTop = $(this).scrollTop();
      let stickyContainerPosTop = stickyElementContainer.offset().top;
      let stickyContainerHeight = stickyElementContainer.height();

      let diff = windowPosTop-stickyContainerPosTop;


      if(window.innerWidth < 992){
        stickyElementInSection.css('position', 'initial');
      }
      else if(stickyContainerPosTop < windowPosTop && diff < stickyContainerHeight-440) {
          stickyElementInSection.css('position', 'fixed');
          stickyElementInSection.css('top', '80px');
      }
      else {
          stickyElementInSection.css('position', 'absolute');

          if((diff+80) > stickyContainerHeight-stickyElementInSection.height()) {
              stickyElementInSection.css('top', 'auto');
              stickyElementInSection.css('bottom', '72px');
          }
          else {
              stickyElementInSection.css('top', '80px');
              stickyElementInSection.css('bottom', 'auto');
          }
      }
  });
});